import { ATRIBUTOS_DOCUMENTO } from '../data/tiposDocumento'
import type { AtributoDocumento, Documento, TipoDocumento } from '../types'

export function formatoEvidencia(numero: number): string {
  return `Evidencia ${String(numero).padStart(3, '0')}`
}

export function siguienteEvidencia(documentos: Documento[]): number {
  const usados = documentos
    .filter((d) => typeof d.numeroEvidencia === 'number')
    .map((d) => d.numeroEvidencia as number)
  return (usados.length ? Math.max(...usados) : 0) + 1
}

export function tipoDelDocumento(
  documento: Documento,
  tipos: TipoDocumento[],
): TipoDocumento | undefined {
  return (
    tipos.find((t) => t.id === documento.tipoId) ?? tipos.find((t) => t.nombre === documento.tipo)
  )
}

/** Atributos exigidos por el catálogo que el documento no tiene capturados. */
export function faltantesDe(documento: Documento, tipo?: TipoDocumento): string[] {
  if (!tipo) return []
  const valor: Record<AtributoDocumento, unknown> = {
    fechaAcuse: documento.fechaAcuse,
    fojas: documento.fojas > 0 ? documento.fojas : undefined,
    autoridadEmisora: documento.autoridadEmisora,
    clasificacion: documento.clasificacion,
    vigencia: documento.vigencia,
    firmaCedula: documento.firmaCedula,
    cadenaCustodia: documento.cadenaCustodia,
  }
  const faltantes = tipo.atributos
    .filter((a) => !valor[a])
    .map((a) => ATRIBUTOS_DOCUMENTO.find((x) => x.clave === a)?.etiqueta ?? a)
  if (tipo.requiereVencimiento && !documento.fechaVencimiento) {
    faltantes.push('Fecha de vencimiento')
  }
  return faltantes
}
